import React, { useEffect, useImperativeHandle, useState } from "react";
import { useSquarePayment } from "../hooks/useSquarePayment";
import { PAYMENT_METHOD_TYPE } from "../../../../../constants/constant";
import { useFormContext } from "react-hook-form";
import calculateCCAfterFee, { calculateFeePercentage } from "../../../../../utils/stripe-payment-fee.util";
import axios from "axios";
import { SQUARE_INITIATE_PAYMENT } from "../../../../../constants/square-endpoints.constant";
import { v4 as uuidv4 } from 'uuid';
import SquareAch from "../ach/square-ach";
import SquareGoogleApplePay from "../square-google-apple-pay/square-google-apple-pay";
import { getHoverColor, getTextColorByBG } from "../../../../../utils/utils";

const SquareCard = React.forwardRef((props, ref) => {
  //props
  const {tokenizeCard } = useSquarePayment(PAYMENT_METHOD_TYPE.CARD);
  const [errorMessage, setErrorMessage] = useState('');
  const { register } = useFormContext();
  const [card, setCard] = useState(null);
  const [loader, setLoading] = useState(false);
  const [finalAmount, setFinalAmount] = useState(0);
  const [paymentAfterFee, setPaymentAfterFee] = useState(0);


  //methods
  useImperativeHandle(ref, () => {
    return {
      setFinalAmount: setFinalAmount
    };
  });
  const handlePayment = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    setLoading(true);
    const cardToken = await tokenizeCard(card);
    // const paymentMethodToken = await tokenizeCard(card);

    if (cardToken.status === "ERROR") {
      // throw new Error("Payment submission failed Error: 422")
      setErrorMessage(cardToken.message);
      setLoading(false);
    } else {
      // Call backend API to process the payment with the token
      try {
        // alert(`Card detail captured your payment token is: ${token}`);
        const donationPayload = props?.returnDonationPayload();
        donationPayload.payment_method_id = cardToken;
        // donationPayload.customer_card_nonce = paymentMethodToken;
        donationPayload.payment_type = 'Card';
        donationPayload.idempotent_key = uuidv4();
        const response = await axios.post(SQUARE_INITIATE_PAYMENT, donationPayload)
        setLoading(false);
        if (response?.data.status === false) {
          setErrorMessage(response?.data?.message);
        } else {
          props?.onPaymentSuccess("Payment successful thank you for your kind donations.");
        }
      } catch (error) {
        setLoading(false);
        setErrorMessage(error?.message || "Payment processing error");
      }
    }
  };

  const calculateStripeFee = (event) => {
    const amount = props?.returnSelectedAmount();
    if (event.target.checked) {
      setFinalAmount(calculateCCAfterFee(amount));
      if (props?.setAmount) {
        props?.setAmount(Math.round(parseFloat(calculateCCAfterFee((amount)) * 100)));
      }

    } else {
      setFinalAmount(amount);
      if (props?.setAmount) {
        props?.setAmount(Math.round(amount * 100));
      }
    }
  }

  const initializeCardForm = async () => {
    try {
      const cardForm = await props?.squareInstance.card();
      await cardForm.attach('#square-payment-card');
      setCard(cardForm)
    } catch (error) {
      setErrorMessage(error?.message);
    }
  }

  useEffect(() => {
    if(props?.squareInstance){
      initializeCardForm();
    }
  }, [props?.squareInstance])

  useEffect(() => {
    if (props?.campaignDetail) {
      const amount = props?.returnSelectedAmount();
      if (props?.campaignDetail?.donation_amount?.ask_donors_cover_fee_default) {
        // setValue('cover_processing_fee',true);
        setFinalAmount(calculateCCAfterFee(amount));
        // if(fieldWatcher?.cover_processing_fee){


        // }else{
        //     setFinalAmount(amount);
        // }
      } else {
        // setValue('cover_processing_fee',false);
        setFinalAmount(amount);
      }

      setPaymentAfterFee(calculateFeePercentage(amount))
    }

  }, [props?.campaignDetail, props?.formValues?.custom_amount, props?.formValues?.selected_amount, props?.amount]);

  return (
    <>
        {
      props?.selectedDonationType?.toLowerCase() === 'one-time' ? 
      
      <SquareAch 
      setErrorMessage={setErrorMessage}
      squareInstance={props?.squareInstance}
      returnDonationPayload={props?.returnDonationPayload}
      campaignDetail={props?.campaignDetail}
      setLoading={setLoading}
      onPaymentSuccess={props?.onPaymentSuccess}
      /> : ''
    }
      <div id="square-payment-card" className="mb-3"></div>

      <div className={`${props?.selectedDonationType?.toLowerCase() === 'one-time' ? 'd-block' : 'd-none'}`}>
        <SquareGoogleApplePay
        squareInstance={props?.squareInstance}
        setStripeButtonElementLoader={props?.setStripeButtonElementLoader}
        formStep={props?.formStep}
        setLoading={setLoading}
        loading={loader}
        selectedDonationType={props?.selectedDonationType}
        onPaymentSuccess={props?.onPaymentSuccess}
        returnDonationPayload={props?.returnDonationPayload}
        calculateStripeFee={calculateStripeFee}
        options={props?.options}
        amount={props?.returnSelectedAmount()}
        campaignDetail={props?.campaignDetail}
      />
      </div>
      <div className='col-lg-12'>
        <div className='d-flex align-items-center justify-content-start'>
          <input
            {...register('cover_processing_fee', {
              value: (props?.campaignDetail?.donation_amount?.ask_donors_cover_fee_default) ? true : false,
              onChange: ((e) => {
                calculateStripeFee(e);
              })
            })} className="me-1" type="checkbox" />
          <label className='f-14'>
            Optionally add ${paymentAfterFee} to cover processing fees
          </label>
        </div>
      </div>
      <div className="col-lg-12 mt-3">
        <div className="text-center position-relative">
          <button onClick={handlePayment} disabled={loader} type="button"
            style={{
              borderRadius: '8px',
               '--primary':  props?.campaignDetail?.primary_color ? (props?.campaignDetail?.primary_color) : '#005B97',
              '--primary-hover': getHoverColor(props?.campaignDetail?.primary_color),
                '--primary-text': getTextColorByBG(props?.campaignDetail?.primary_color),
            }} className={`btn text-white btn-step-one w-100 f-18`}>
            <i className="cursor-pointer me-2"></i>

            {(loader) ? "Processing ... " : `${props?.campaignDetail?.donation_amount?.change_label_to_pay ? 'Pay' : 'Donate'} 
                            $${Number.isInteger(finalAmount) ? finalAmount : parseFloat(finalAmount)?.toFixed(2)
              }
                            ${props?.selectedDonationType}`}
          </button>
        </div>
        {errorMessage && <div className={`f-xsmall text-danger text-center`} id="payment-message">{errorMessage}</div>}
      </div>
    </>
  );
});

export default SquareCard;
